import {
  ActionsObservable,
  combineEpics,
  StateObservable
} from 'redux-observable';
import { from, of, timer } from 'rxjs';
import {
  catchError,
  exhaustMap,
  mergeMap,
  startWith,
  switchMap,
  takeUntil
} from 'rxjs/operators';
import axios from '../../axios-pod';
import { IState } from '../../models/states';
import actionTypes from '../../utilities/actionTypes';

import {
  deleteAgentSuccess,
  fetchAgents,
  fetchAgentsPending,
  fetchAgentsSuccess,
  fetchSkynetConfig,
  fetchSkynetConfigSuccess,
  IAddAgent,
  IDeleteAgent,
  IFetchAgents,
  IFetchSkynetConfig,
  IUpdateAgent,
  IUpdateSkynetConfig
  // updateAgentSuccess
} from '../actions/agentAction';

export const onLoadAgents = (
  action$: ActionsObservable<IFetchAgents>,
  state$: StateObservable<IState>
) =>
  action$.ofType(actionTypes.FETCH_AGENTS).pipe(
    switchMap((action: IFetchAgents) => {
      return timer(
        0,
        globalThis.UI_CONFIG ? globalThis.UI_CONFIG.agent_poll_time : 10000
      ).pipe(
        takeUntil(action$.ofType(actionTypes.FETCH_AGENTS_CANCEL)),
        switchMap(() => {
          const params = { userId: state$.value.user.userInfo.userId };
          return from(axios.get('/agents', { params })).pipe(
            mergeMap(response => {
              const result: any[] = [fetchAgentsSuccess(response.data.result)];
              return result;
            }),
            startWith(fetchAgentsPending()),
            catchError(_ => of())
          );
        })
      );
    })
  );
export const onLoadSkynetConfig = (
  action$: ActionsObservable<IFetchSkynetConfig>,
  state$: StateObservable<IState>
) =>
  action$.ofType(actionTypes.FETCH_SKYNET_CONFIG).pipe(
    exhaustMap((action: IFetchSkynetConfig) => {
      const params = { userId: state$.value.user.userInfo.userId };
      return from(axios.get(`rules`, { params })).pipe(
        mergeMap(res => {
          const result: any[] = [fetchSkynetConfigSuccess(res.data.result)];
          return result;
        }),
        catchError(_ => of())
      );
    })
  );
export const onUpdateAgent = (action$: ActionsObservable<IUpdateAgent>) =>
  action$.ofType(actionTypes.UPDATE_AGENT).pipe(
    switchMap((action: IUpdateAgent) => {
      return from(axios.put('/edit_sentinel_config', action.payload)).pipe(
        mergeMap((response: any) => {
          // return [updateAgentSuccess(response.data.result)];
          return [fetchAgents()];
        }),
        catchError(_ => of())
      );
    })
  );

export const onUpdateSkynetConfig = (
  action$: ActionsObservable<IUpdateSkynetConfig>
) =>
  action$.ofType(actionTypes.UPDATE_SKYNET_CONFIG).pipe(
    switchMap((action: IUpdateSkynetConfig) => {
      return from(axios.put('/edit_rule', action.payload)).pipe(
        mergeMap((response: any) => {
          return [fetchSkynetConfig()];
        }),
        catchError(_ => of())
      );
    })
  );

export const onAddAgent = (action$: ActionsObservable<IAddAgent>) =>
  action$.ofType(actionTypes.ADD_AGENT).pipe(
    exhaustMap((action: IAddAgent) => {
      const payload = {
        customer: action.payload.customer,
        sentinel_id: action.payload.customer.concat('_manual')
      };
      return from(axios.post(`sentinel`, payload)).pipe(
        mergeMap((response: any) => {
          return [fetchAgents()];
        }),
        catchError(_ => of())
      );
    })
  );

export const onDeleteAgent = (action$: ActionsObservable<IDeleteAgent>) =>
  action$.ofType(actionTypes.DELETE_AGENT).pipe(
    exhaustMap((action: IDeleteAgent) => {
      return from(axios.delete(`/delete_agent/${action.customer}`)).pipe(
        mergeMap(_ => {
          const result: any[] = [
            deleteAgentSuccess(action.customer),
            fetchAgents()
          ];
          return result;
        }),
        catchError(_ => of())
      );
    })
  );
export default combineEpics(
  onLoadAgents,
  onUpdateAgent,
  onLoadSkynetConfig,
  onUpdateSkynetConfig,
  onAddAgent,
  onDeleteAgent
);
